import { PlayerInfo, ProfileInfo } from "./common/Info";
import ReadyBadge from "./ReadyBadge";
import "./PlayerIcon.css";
import KickButton from "./KickButton";

import astronaut from "./assets/avatars/astronaut.svg";
import astronautDisabled from "./assets/avatars/astronaut-black-and-white.svg";
import chef from "./assets/avatars/chef.svg";
import chefDisabled from "./assets/avatars/chef-black-and-white.svg";
import clerk from "./assets/avatars/clerk.svg";
import clerkDisabled from "./assets/avatars/clerk-black-and-white.svg";
import doorman from "./assets/avatars/doorman.svg";
import doormanDisabled from "./assets/avatars/doorman-black-and-white.svg";
import dustman from "./assets/avatars/dustman.svg";
import dustmanDisabled from "./assets/avatars/dustman-black-and-white.svg";
import farmer from "./assets/avatars/farmer.svg";
import farmerDisabled from "./assets/avatars/farmer-black-and-white.svg";
import gardener from "./assets/avatars/gardener.svg";
import gardenerDisabled from "./assets/avatars/gardener-black-and-white.svg";
import photographer from "./assets/avatars/photographer.svg";
import photographerDisabled from "./assets/avatars/photographer-black-and-white.svg";
import sailor from "./assets/avatars/sailor.svg";
import sailorDisabled from "./assets/avatars/sailor-black-and-white.svg";
import stewardess from "./assets/avatars/stewardess.svg";
import stewardessDisabled from "./assets/avatars/stewardess-black-and-white.svg";
import waiter from "./assets/avatars/waiter.svg";
import waiterDisabled from "./assets/avatars/waiter-black-and-white.svg";
import worker from "./assets/avatars/worker.svg";
import workerDisabled from "./assets/avatars/worker-black-and-white.svg";

interface PlayerIconProps {
  player: PlayerInfo;
  profile: ProfileInfo;
}

function generateHashCode(text: string): number {
  let hash = 0,
    i,
    chr;
  if (text.length === 0) return hash;
  for (i = 0; i < text.length; i++) {
    chr = text.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  if (hash < 0) {
    hash *= -1;
  }
  return hash;
}

function PlayerIcon({ player, profile }: PlayerIconProps) {
  const onlineAvatars = [
    astronaut,
    chef,
    clerk,
    doorman,
    dustman,
    farmer,
    gardener,
    photographer,
    sailor,
    stewardess,
    waiter,
    worker,
  ];
  const onlineAvatarsDisabled = [
    astronautDisabled,
    chefDisabled,
    clerkDisabled,
    doormanDisabled,
    dustmanDisabled,
    farmerDisabled,
    gardenerDisabled,
    photographerDisabled,
    sailorDisabled,
    stewardessDisabled,
    waiterDisabled,
    workerDisabled,
  ];

  const nameHash = generateHashCode(player.name);
  const index = nameHash % onlineAvatars.length;
  let kickButton = <span></span>;

  let imgSrc: string;

  let connected = player.connected;

  // If this is the current player just assume the player is connected
  if (player.id === profile.id) {
    connected = true;
  }

  if (connected) {
    imgSrc = onlineAvatars[index];
  } else {
    imgSrc = onlineAvatarsDisabled[index];
    kickButton = <KickButton id={player.id} />;
  }

  return (
    <div className="playerIconContainer">
      <img className="playerIcon" src={imgSrc} />
      <div className="nameContainer">
        <div className="center">{player.name}</div>
      </div>
      {kickButton}
      <ReadyBadge enabled={player.ready} />
    </div>
  );
}

export default PlayerIcon;
